
<div class="artist-header">
  <img [src]="(wideImage && !wideImage.includes('noimage')) ? wideImage : artistProfilePhoto" class="artist-desktop-only" loading="lazy" alt="Artist Image">


  <!-- <img [src]="artistProfilePhoto" class="artist-mobile-only" loading="lazy" alt="Artist Image"> -->
  <ng-container *ngIf="isAvifImage(artistProfilePhoto); else normalImage">
    <picture>
      <source
        media="(max-width:649px)"
        [srcset]="artistMidProfilePhoto"
      />
      <source
        media="(min-width:650px)"
        [srcset]="artistProfilePhoto"
      />
  
      <img
        class="noGallery artist-mobile-only"
        [src]="eventNoSrc"
        [alt]="artistName"
        loading="lazy"
      />
    </picture>
  </ng-container>
  
  <ng-template #normalImage>
    <img
      class="noGallery artist-mobile-only"
      loading="lazy"
      [src]="artistProfilePhoto"
      [alt]="artistName"
    />
  </ng-template>
  <h1 class="mobile-artist-name artist-mobile-only">{{artistName}}</h1>
</div>
<div class="artist-content">
  <div class="content"  fxLayout.gt-sm="row" fxLayout="column" fxLayoutGap.gt-sm="50px">
    <div class="left-col"  fxFlex="100%" fxFlex.gt-sm="25%">
      <!-- <img [src]="artistProfilePhoto" class="artist-desktop-only" loading="lazy" alt="Artist Image"> -->

      <ng-container *ngIf="isAvifImage(artistProfilePhoto); else normalImageDesk">
        <picture>
          <source
            media="(max-width:649px)"
            [srcset]="artistMidProfilePhoto"
          />
          <source
            media="(min-width:650px)"
            [srcset]="artistProfilePhoto"
          />
      
          <img
            class="noGallery artist-desktop-only"
            [src]="eventNoSrc"
            [alt]="artistName"
            loading="lazy"
          />
        </picture>
      </ng-container> 
      <ng-template #normalImageDesk>
        <img
          class="noGallery artist-desktop-only"
          loading="lazy"
          [src]="artistProfilePhoto"
          [alt]="artistName"
        />
      </ng-template>

      <div id="mobile-version" class="artist-mobile-only event-info-wrapper" id="about" fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column" class="artistList">
          <h2
            class="calendar-header"
            translate="performance.labels.eventCalendar"
          ></h2>
          <div *ngIf="eventsDetailByArtist[0]" class="button-container" id="eventCalendar">

            <button
              class="button"
              style="border-radius: 4px 0 0 4px"
              (click)="this.calendarOrListStatus = true;"
              [ngStyle]="{
                'background-color': calendarOrListStatus ? '#026CDF' : '',
                color: calendarOrListStatus ? 'white' : ''
              }"
            >
              <mat-icon>calendar_today</mat-icon>
              <span>{{ 'performance.links.calendar' | translate }}</span>
            </button>
            <button
              class="button"
              style="border-radius: 0 4px 4px 0"
              (click)="calendarOrListStatus = false"
              [ngStyle]="{
                'background-color': !calendarOrListStatus ? '#026CDF' : '',
                color: !calendarOrListStatus ? 'white' : ''
              }"
            >
              <mat-icon>list</mat-icon>
              <span>{{ 'performance.links.list' | translate }}</span>
            </button>
          </div>
          <span class="no-event-text" *ngIf="!eventsDetailByArtist[0]">{{'shared.labels.noEvent'| translate}}</span>
          <div *ngIf="eventsDetailByArtist[0]">
            <ng-container *ngIf="!calendarOrListStatus">
              <ng-container *ngFor="let item of groupEventForList()">
                <btx-artist-list-item [listItem]="item"></btx-artist-list-item>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="calendarOrListStatus">
              <btx-calendar [data]="eventsDetailByArtist" [eventName]="eventsDetailByArtist[0].eventName" [type]="'venue'"></btx-calendar>
            </ng-container>
          </div>
        </div>

      </div>


      <div class="artist-social-media-wrapper">

        <div class="artist-social-media">
          <div class="social-media">
            <h5>{{'shared.labels.followTheArtist'| translate}}</h5>
            <ul class="social">
              <li *ngIf="artistYoutubeUrl" class="youtube"><a [href]="artistYoutubeUrl" target="_blank"></a></li>
              <li *ngIf="artistInstagramUrl" class="instagram"><a [href]="artistInstagramUrl" target="_blank"></a></li>
              <li *ngIf="artistFacebookUrl" class="facebook"><a [href]="artistFacebookUrl" target="_blank"></a></li>
              <li *ngIf="artistXUrl" class="x"><a [href]="artistXUrl" target="_blank"></a></li>
              <li *ngIf="artistSpotifyUrl" class="spotify"><a [href]="artistSpotifyUrl" target="_blank"></a></li>
            </ul>
          </div>
        </div>

        <div class="spotify-container" *ngIf="spotifyId && spotifyId.trim() !== ''" id="spotify">
          <iframe style="border-radius:12px"
                  [src]="getEmbeddedSpotifyUrl() | safe: 'resourceUrl'"
                  width="100%" height="352"
                  frameBorder="0" allowfullscreen=""
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"></iframe>
        </div>

        <btx-artist-past-performances fxHide fxShow.gt-sm="true" id="pastPerformance"></btx-artist-past-performances>

      </div>
    </div>
    <div class="right-col" fxFlex="100%" fxFlex.gt-sm="75%" fxLayout="column">
      <h1 class="artist-desktop-only">{{artistName}}</h1>
      <div class="artist-desktop-only event-info-wrapper" id="about" fxLayout="column" fxLayoutGap="10px">
        
        <div fxLayout="column" class="artistList">
          <div class="event-list-head-holder" fxLayout="row" fxLayoutAlign="space-between start">
            <h2
            class="calendar-header"
            translate="performance.labels.eventCalendar"
            ></h2>
            
            <div *ngIf="eventsDetailByArtist[0]" class="button-container" id="eventCalendar">

              <button
                class="button"
                style="border-radius:4px 0 0 4px;"
                (click)="this.calendarOrListStatus = true;"
                [ngStyle]="{
                  'background-color': calendarOrListStatus ? '#026CDF' : '',
                  color: calendarOrListStatus ? 'white' : ''
                }"
              >
                <mat-icon>calendar_today</mat-icon>
                <span>{{ 'performance.links.calendar' | translate }}</span>
              </button>
              <button
                class="button"
                style="border-radius: 0 4px 4px 0;"
                (click)="calendarOrListStatus = false"
                [ngStyle]="{
                  'background-color': !calendarOrListStatus ? '#026CDF' : '',
                  color: !calendarOrListStatus ? 'white' : ''
                }"
              >
                <mat-icon>list</mat-icon>
                <span>{{ 'performance.links.list' | translate }}</span>
              </button>
            </div>
          </div>
          <span class="no-event-text" *ngIf="!eventsDetailByArtist[0]">{{'shared.labels.noEvent'| translate}}</span>
          <div *ngIf="eventsDetailByArtist[0]">
            <ng-container *ngIf="!calendarOrListStatus">
              <ng-container *ngFor="let item of groupEventForList()">
                <btx-artist-list-item [listItem]="item"></btx-artist-list-item>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="calendarOrListStatus">
              <btx-calendar [data]="eventsDetailByArtist" [eventName]="eventsDetailByArtist[0].eventName" [type]="'venue'"></btx-calendar>
            </ng-container>
          </div>
        </div>

      </div>

      <h2 *ngIf="artistTextDescription" class="title heading-medium" translate="account.labels.packageAbout"></h2>
      <btx-read-more  *ngIf="artistTextDescription" [text]="artistTextDescription" [maxLength]="10000"></btx-read-more>

      <btx-artist-past-performances class="artist-mobile-only" id="pastPerformance"></btx-artist-past-performances>

      <h2 *ngIf="videoURL && videoURL.length > 0" class="artist-desktop-only title heading-medium">{{'shared.labels.gallery'| translate}}</h2>
      <div class="artist-desktop-only" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="30px">
        <!-- <div *ngFor="let video of videoURL">
          <div class="video-holder">
            <iframe width="560" height="315" [src]="getVideoUrl(video) |  safe: 'resourceUrl'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div> -->
        <div class="video-holder" *ngFor="let video of videoURL">
          
          <a
            [href]="getVideoUrl(video) |  safe: 'resourceUrl'"
            data-fancybox
            data-width="100%"
            data-height="100%"
          >
            <img
            [src]="getVideoThumbnail(video)" 
              alt="Video poster"
            />
          </a>
          <div class="icon"><svg  viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="#fff" d="M12 21.5a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19m0 1.5a11 11 0 1 0 0-22 11 11 0 0 0 0 22M9.87 7.35 8.75 8v8l1.12.65 7-4v-1.3z"></path></svg></div>
        </div>
      </div>
      <!-- <div *ngFor="let video of videoURL">
        <a
          [href]="getVideoUrl(video) |  safe: 'resourceUrl'"
          data-fancybox
          data-width="100%"
          data-height="100%"
        >
          <img
          [src]="getVideoThumbnail(video)" 
            alt="Video poster"
            width="240"
            height="180"
          />
        </a>
        <swiper class="mySwiper"  [spaceBetween]="20" [slidesPerView]="2" [pagination]="true">

          <ng-template swiperSlide *ngFor="let video of videoURL">
            <div data-fancybox="gallery">
              <div class="video-holder">
                <iframe width="560" height="315" [src]="getVideoUrl(video) |  safe: 'resourceUrl'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
              <img [src]="getVideoThumbnail(video)"  loading="lazy" style="width: 100%" alt="">
            </div>
          </ng-template>
        </swiper>
      </div> -->
    </div>
  </div>
</div>

